export default __webpack_public_path__ + "static/media/logout.00a79d7f.svg";